<template lang="pug">
  .coach-list
    f7-row(no-gap)
      coach-list-item(
        v-for="coach in coaches"
        :key="coach.id"
        :coach="coach"
        @click="$emit('click', coach.id)"
        @reviewClick="$emit('reviewClick', coach.id)")

</template>

<style lang="scss" scoped>
.coach-list {
  position: relative;
  z-index: -1;
  padding: 0px;

  .coach-list-item:nth-child(odd) {
    margin-right: 1.5px;
  }

  .coach-list-item:nth-child(even) {
    margin-left: 1.5px;
  }
}
</style>

<script>
import CoachListItem from '@/components/molecules/CoachListItem'

export default {
  components: {
    CoachListItem,
  },
  props: {
    coaches: {
      type: Array,
      required: true,
    },
  },
}
</script>
